import { RepairPriority, RepairPriorityCode } from "../Repair/CreateRepair";

export const PriorityFilter = [
    {
        key: 'Select',
        value: ''
    },
    {
        key: RepairPriority.DampAndMouldLowRisk,
        value: RepairPriorityCode.DampAndMouldLowRisk
    },
    {
        key: RepairPriority.DampAndMouldSignificant,
        value: RepairPriorityCode.DampAndMouldSignificant
    },
    {
        key: RepairPriority.DM14Days,
        value: RepairPriorityCode.DampAndMould
    },
    {
        key: RepairPriority.DM24Hours,
        value: RepairPriorityCode.DampAndMouldEmergency
    },
    {
        key: RepairPriority.Emergency,
        value: RepairPriorityCode.Emergency
    },
    {
        key: RepairPriority.NextAvailable,
        value: RepairPriorityCode.NextAvailable
    },
    {
        key: RepairPriority.NextAvailable14Days,
        value: RepairPriorityCode.V14
    }
]